// @flow

import React from 'react';
import { InputV2, InputConsumer } from '@catalytic/catalytic-ui';
import { types } from '@catalytic/react-view';
import useFieldContext from './FieldContext';
import { useHandleBlur, useHandleChange } from './ViewHelpers';
import MarkdownInput from '../shared/MarkdownInput/MarkdownInput';

const RichTextView = ({
  schema: getSchema,
  setValue,
  value
}: types.TextAreaView) => {
  const schema = getSchema();
  const fieldContext = useFieldContext();
  const {
    className,
    context,
    description,
    disabled,
    displayErrors,
    displayName,
    embedded,
    example,
    hasValidation,
    id,
    name,
    onBlur,
    onChange,
    readOnly,
    required,
    type
  } = fieldContext || {};
  const handleBlur = useHandleBlur({ onBlur, setValue, type });
  const handleChange = useHandleChange({ onChange, setValue, type });

  return (
    <InputV2
      className={className}
      description={description}
      disabled={disabled}
      displayErrors={displayErrors}
      example={example}
      hasValidation={hasValidation}
      id={id}
      name={name}
      onBlur={handleBlur}
      onChange={handleChange}
      readOnly={readOnly}
      schema={schema}
      title={displayName}
      type={type}
      value={value}
    >
      <InputConsumer>
        {props => (
          <MarkdownInput
            context={context}
            defaultValue={value || ''}
            embedded={embedded}
            id={id}
            name={name}
            required={required}
            {...props}
          />
        )}
      </InputConsumer>
    </InputV2>
  );
};
RichTextView.displayName = 'RichTextView';

export default React.memo<types.RichTextView>(RichTextView);
